export enum LoyaltyLimitType {
  NoLimit = 0,
  LimitByMember = 1,
  LimitByAccount = 2
}
